var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoorbellChime02({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 6.5,
    className: "st0",
    width: 4.7,
    height: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.7,13.3c2.9,0,5.3-2.4,5.3-5.3s-2.4-5.3-5.3-5.3V13.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorbellChime02);
export default __webpack_public_path__ + "static/media/DoorbellChime-02.8283c44ca3531ccdec82c5df570a2278.svg";
export { ForwardRef as ReactComponent };